<template>
  <div
    class="absolute hover:z-[999] cursor-pointer"
    :class="{ ' hover:scadle-[1.3]': !isMultiple, group: !explode }"
  >
    <div
      v-if="!explode"
      class="
        group-hover:block group-hover:pointer-events-auto
        rounded-box
        w-64
        ml-2
        transition-all
        group-hover:animate-animated group-hover:animate-fadeInRight
        absolute
        hidden
        pointer-events-none
        z-[100]
        bg-base-200
        text-base-content
        translate-y-[-50%]
        p-2
        top-1/2
        left-12
        ring-2
        text-sm
      "
    >
      <template v-if="!isMultiple">
        <span class="text-sm font-bold">
          {{ items[0].name }}
        </span>
        <div class="text-sm">
          Importance :
          <span class="font-bold">{{ items[0].importance.id }}</span>
        </div>
        <div class="text-sm">
          Facilité :
          <span class="font-bold">{{ items[0].facility.id }}</span>
        </div>

        <div class="mt-4 text-xs italic">
          Cliquez pour modifier la priorisation de l'activité
        </div></template
      >

      <template v-else>
        <span class="text-sm font-bold"> Activité superposés </span>

        <div class="text-sm" v-for="item in items" :key="item.$id">
          {{ item.name }}
        </div>

        <div class="mt-4 text-xs italic text-secondary">
          Cliquez pour voir tout
        </div>
      </template>
    </div>
    <div
      :class="{
        'bg-secondary text-secondary-content': isMultiple,
      }"
      @click="isMultiple && (explode = true)"
      class="flex items-center justify-center w-12 h-12 p-1 overflow-hidden font-bold uppercase transform rounded-full  bg-primary text-primary-content animate-animated animate-zoomIn ring-2 ring-base-100 animate-duration-300"
    >
      <span class="animate-animated animate-fadeIn" v-if="!isMultiple"
        >A{{ items[0].$id }}</span
      >
      <span
        class="animate-animated animate-fadeIn"
        v-if="isMultiple && !explode"
        >+{{ items.length }}</span
      >
      <span
        class="animate-animated animate-fadeIn"
        @click="explode = x"
        v-if="isMultiple && explode"
        >x</span
      >
    </div>

    <div v-if="explode && isMultiple" class="bg-black bg-opacity-0">
      <div
        @click.self="explode = false"
        class="
          absolute
          rounded-full
          top-1/2
          left-1/2
          translate-x-[-50%] translate-y-[-50%]
          w-48
          h-48
          shadow-2xl
          animate-animated animate-zoomIn
        "
      >
        <MPBullet
          :style="{
            top: `${
              Math.sin(((2 * Math.PI) / items.length) * (y + 1)) * 96 + 96
            }px`,
            left: `${
              Math.cos(((2 * Math.PI) / items.length) * (y + 1)) * 96 + 96
            }px`,
          }"
          :class="{
            '  absolute': true,
          }"
          class="-translate-x-1/2 -translate-y-1/2"
          v-for="(i, y) of items"
          :items="[i]"
          :key="i.$id"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MPBullet",

  props: {
    items: Array,

    shouldhover: Boolean,
  },
  mounted() {
    console.log(this.items);
  },
  computed: {
    isMultiple() {
      return this.items.length > 1;
    },
  },
  data() {
    return {
      implications: {
        symbol: ["+", "-", "!"],
      },
      explode: false,
    };
  },
};
</script>

<style>
</style>
